export default "/static/assets/account.83f7e45f79af93e6b483f8d964dadc1a.svg";